/**
 * 日志工具类
 * 在生产环境中自动禁用console输出，防止敏感信息泄露
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * 安全的日志输出类
 */
class Logger {
  log(...args: any[]): void {
    if (isDevelopment) {
      console.log(...args);
    }
  }

  error(...args: any[]): void {
    // 错误日志在生产环境也输出，但只输出错误信息，不输出敏感数据
    if (isDevelopment) {
      console.error(...args);
    } else {
      // 生产环境只输出错误消息，不输出完整对象
      const messages = args.map(arg => {
        if (arg instanceof Error) {
          return arg.message;
        }
        if (typeof arg === 'string') {
          return arg;
        }
        return '[Object]';
      });
      console.error(...messages);
    }
  }

  warn(...args: any[]): void {
    if (isDevelopment) {
      console.warn(...args);
    }
  }

  info(...args: any[]): void {
    if (isDevelopment) {
      console.info(...args);
    }
  }

  debug(...args: any[]): void {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
}

export const logger = new Logger();

